<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
export default {
  components: { swiper, swiperSlide },
  data() {
    const $self = this;
    const DEFAULT_PAGE_COUNT = 1;
    return {
      swiperOption: {
        slidesPerView: 1,
        speed: 600,
        loop: false,
        slidesPerGroup : 1,
        spaceBetween: 120,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        // initialSlide: DEFAULT_PAGE_COUNT - 1,
        on: {
          slideChange () {
            const index = ( this.activeIndex % $self.list.length ) || 0;
            $self.setSlide(index)
          }
        },
      },
      list: [
        {
          img1: require('@assets/images/home/section6-user-image@2x 2.png'),
          img2: require('@assets/images/home/section6-user-image@2x.png'),
          title: '小捲尾寵物精品美容&SPA創辦人',
          content: '<p>大家好，我經營一間寵物美容店，同時也是多隻毛小孩的主人，以站在毛爸媽角度為出發點，希望毛孩們在美容洗澡的時光能得到最棒的服務！因次，我選擇了 iPetBooking，他讓我們能以快速便利的整合線上與線下的預約，節省了好多時間，讓我們更能專注在安排美容師們的工作、記錄毛小孩們的狀況，並提供更貼心專業的美容服務。我詢問過幾個預約服務的系統，但通用各行各業的軟體服務總是無法達到我對於寵物美容服務上的需求。到目前為止， iPetBooking是非常方便、最容易使用上手的。真心推薦給所有寵物服務業者們！<p>'
        },
        // {
        //   img1: require('@assets/images/home/section6-user-image@2x 2.png'),
        //   img2: require('@assets/images/home/section6-user-image@2x.png'),
        //   title: '小捲尾寵物精品美容&SPA創辦人2',
        //   content: '<p>大家好，我經營一間寵物美容店，同時也是多隻毛小孩的主人，以站在毛爸媽角度為出發點，希望毛孩們在美容洗澡的時光能得到最棒的服務！因次，我選擇了 iPetBooking，他讓我們能以快速便利的整合線上與線下的預約，節省了好多時間，讓我們更能專注在安排美容師們的工作、記錄毛小孩們的狀況，並提供更貼心專業的美容服務。我詢問過幾個預約服務的系統，但通用各行各業的軟體服務總是無法達到我對於寵物美容服務上的需求。到目前為止， iPetBooking是非常方便、最容易使用上手的。真心推薦給所有寵物服務業者們！<p>'
        // },
      ]
    }
  },
  methods: {
    setSlide(index) {
      this.$refs.carouselCustom.swiper.slideTo(index, 600)
    },
    onNext() {
      this.$refs.carouselCustom.swiper.slideNext()
    },
    onPrev() {
      this.$refs.carouselCustom.swiper.slidePrev()
    },
  },
}
</script>

<template>
  <div :class="$style.sectionCustom">
    <div class="container section">
      <BaseSectionTitle 
        title="聽聽i寵訂客戶怎麼說"
        sub-title="Client Feedback" 
        class="isStyleDecoration text-center isCenter mx-auto"
      />
      <div class="sectionCustom__slide">
        <swiper
          ref="carouselCustom"
          :options="swiperOption"
          class="sectionCustom__list"
        >
          <swiper-slide
            v-for="(item, $index) in list"
            :key="$index"
            class="sectionCustom__item"
          >
            <div class="contentBox">
              <div class="sectionCustom__content" v-html="item.content"></div>
              <div class="sectionCustom__title text-center mt-md-5 mt-4">
                <img
                  :src="item.img1" 
                  :srcset="`${item.img1} 1x, ${item.img2} 2x`"  
                  alt=""
                >
                <span class="pl-2">{{item.title}}</span>
              </div>
            </div>
          </swiper-slide>
          <div
            class="swiper-pagination mt-md-5 mt-4" 
            slot="pagination">
          </div>
        </swiper>
        <div 
          v-if="list.length > 1"
          class="navigationBox d-lg-block d-none"
        >
          <button class="navigationBtn isPrev" @click="onPrev">
            <i class="icomoon icon-arrow-left"></i>
          </button>
          <button class="navigationBtn isNext" @click="onNext">
            <i class="icomoon icon-arrow-button"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
  .sectionCustom {
    position: relative;
    &:after {
      content:'';
      position: absolute;
      bottom: -5%;
      left: 0;
      right: 0;
      background-image: url('@assets/images/home/section6-bg.svg');
      background-repeat: no-repeat;
      background-size: cover;
      width: 100vw;
      height: 100%;

    }
    :global {
      .sectionCustom {
        &__list {
          width: 1028px;
          max-width: 100%;
          // margin-top: 50px;
          padding-left: 100px;
          padding-right: 100px;
          position: relative;
          @include max-lg {
            padding-left: 10px;
            padding-right: 10px;
          }
          &:before {
            content: url('~@assets/images/home/section6-paw-left.svg');
            position: absolute;
            left: 50px;
            z-index: 2;
            @include max-lg {
              display: none;
            }
          }
          &:after {
            content: url('~@assets/images/home/section6-paw-right.svg');;
            position: absolute;
            right: -10px;
            bottom: 70px;
            @include max-lg {
              display: none;
            }
          }
        }
        &__item {

          background: #FFFFFF;
          box-shadow: 0px 3px 24px rgba(84, 86, 98, 0.1);
          border-radius: 10px;
          margin-top: 30px;
          margin-bottom: 80px;
          padding: 57px 100px;
          @include max-md {
            padding: 24px 36px;
            margin-bottom: 50px;
            font-size: 14px;
          }
        }
        &__title {
          font-weight: 600;
          font-size: 18px;
          @include max-md {
            font-size: 16px;
          }
        }
        &__slide {
          position: relative;
        }
      }
      .swiper-pagination {
          bottom: -5px;
      }
      .swiper-pagination-bullet-active {
        background: $color-primary;
      }
      .navigationBox {
        position: absolute;
        top: 50%;
        left: 0;
        z-index: 1;
        width: 100%;
        margin-bottom: 30px;
        // @include touch {
        //   width: 100vw
        // }
        @include max-lg {
          top: 30%;
        }
        .navigationBtn {
          position: absolute;
          top: 50%;
          width: 100px;
          height: 200px;
          margin-top: -100px;
          color: rgba(156, 159, 176, 1);
          text-align: left;
          background: transparent;
          border: unset;
          appearance: none;
          font-size: 30px;
          transition: .3s;
          @include max-sm {
            margin-top: -120px;
          }
          &:focus {
            outline: none;
          }
          &:active {
            opacity: 0.5;
          }
          &.isDisabled {
            opacity: 0.3;
          }
          // .arrowIcon {
          //   @apply text-text-dark;
          //   &::before {
          //     display: block;
          //     margin: auto;
          //     font-family: 'fontello';
          //     font-size: 42px;
          //     content: $fontello-arrow-left;
          //     background-repeat: no-repeat;
          //     background-position: center;
          //     opacity: 1;
          //   }
          //   &:hover {
          //     &::before {
          //       opacity: 0.5;
          //     }
          //   }
          // }
          &:hover {
            color: $color-primary;
          }
          &.isPrev {
            left: 0;
          }
          &.isNext {
            right: 0;
            text-align: right;
            .arrowIcon {
              &::before {
                transform: scaleX(-1);
              }
            }
          }
        }
      }
    }
  }

</style>